import React from 'react';

import RouterLinkButton from 'src/presentation/components/RouterLinkButton';

const CampaignActions = ({ root }) => (
  <RouterLinkButton data-aid="campaigns-addNew-button" to={`${root}/new`}>
    Create Campaign
  </RouterLinkButton>
);

export default CampaignActions;
